import { type FieldValidation } from '../../validation/protocols/field-validation'

export class MinItemsValidation implements FieldValidation {
  readonly field: string

  constructor (field: string) {
    this.field = field
  }

  validate (value: string): Error | null {
    try {
      const json = JSON.parse(value)
      if (json.length === 0) return new Error('Você preceisa selecionar pelo menos 1 opção')
      return null
    } catch (error) {
      return new Error('Você preceisa selecionar pelo menos 1 opção')
    }
  }
}
